export default IconCe => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-ce" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M9 6a6 6 0 1 0 0 12" />
  <path d="M21 6a6 6 0 1 0 0 12" />
  <path d="M15 12h6" />
</svg>`;